const menuItems = [
  { iconType: 'dashboard', linkTarget: 'https://digital.mymax.com', linkName: 'Dashboard' },
  { iconType: 'messages', linkTarget: 'https://digital.mymax.com/messages', linkName: 'Messages' },
  { iconType: 'accounts', linkTarget: 'https://digital.mymax.com/accounts/', linkName: 'Accounts' },
  { iconType: 'support', linkTarget: 'https://digital.mymax.com/support', linkName: 'Support' },

];

export default menuItems;